import { render, staticRenderFns } from "./Paginatation.vue?vue&type=template&id=4f75a63d&"
import script from "./Paginatation.vue?vue&type=script&lang=js&"
export * from "./Paginatation.vue?vue&type=script&lang=js&"
import style0 from "./Paginatation.vue?vue&type=style&index=0&id=4f75a63d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports